const UserCircleIcon = ({ color }: { color?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 20 20" fill="none">
    <g clip-path="url(#clip0_5005_38630)">
      <path
        d="M5.83325 15V14.1667C5.83325 11.8655 7.69873 10 9.99992 10V10C12.3011 10 14.1666 11.8655 14.1666 14.1667V15"
        stroke={color ?? "currentColor"}
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M10 10C11.3807 10 12.5 8.88071 12.5 7.5C12.5 6.11929 11.3807 5 10 5C8.61929 5 7.5 6.11929 7.5 7.5C7.5 8.88071 8.61929 10 10 10Z"
        stroke={color ?? "currentColor"}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <circle cx="10.0001" cy="9.99996" r="8.33333" stroke={color ?? "currentColor"} stroke-width="1.5" />
    </g>
    <defs>
      <clipPath id="clip0_5005_38630">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default UserCircleIcon;
